
export default function DetailedCourseExampleCardHeader({headerTitle, children}) {
    // Used in Results Cards to display card header information
    // made of text and additional element (children)

    // BUILD
    return (
        <div className="w-full flex justify-between px-[12px] pt-[8px]">
            <span className="text-greyLight7 text-[14px] font-medium">
                {headerTitle}
            </span>
            {children}
        </div>
    );
}